import { NgModule } from '@angular/core';
import { mapToCanActivate, RouterModule, Routes } from '@angular/router';
import { AuthSsoLogoutComponent } from '@kp/screen-login/auth-sso-logout/auth-sso-logout.component';
import { CodeComponent } from '@kp/screen-login/code/code.component';
import { ExistingAccountComponent } from '@kp/screen-login/existing-account/existing-account.component';
import { LoginChoiceComponent } from '@kp/screen-login/login-choice/login-choice.component';
import { LoginHeaderComponent } from '@kp/screen-login/login-header/login-header.component';
import { PasswordResetComponent } from '@kp/screen-login/password-reset/password-reset.component';
import { ResendCodeComponent } from '@kp/screen-login/resend-code/resend-code.component';
import { ScreenLoginComponent } from '@kp/screen-login/screen-login.component';
import { SendCodeComponent } from '@kp/screen-login/send-code/send-code.component';
import { LoginGuard } from '@kp/shared/guards/login.guard';

const routes: Routes = [
  { path: '', pathMatch: 'full', component: LoginChoiceComponent, canActivate: mapToCanActivate([LoginGuard]) },
  { path: 'email', pathMatch: 'full', component: ScreenLoginComponent, canActivate: mapToCanActivate([LoginGuard]) },
  { path: 'existing_account', pathMatch: 'full', component: ExistingAccountComponent },
  { path: 'reset/password', component: PasswordResetComponent },
  { path: 'reset/code', component: SendCodeComponent },
  { path: 'reset/code/resend', component: ResendCodeComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ScreenLoginRoutingModule {
  static components = [
    AuthSsoLogoutComponent,
    CodeComponent,
    ExistingAccountComponent,
    LoginChoiceComponent,
    LoginHeaderComponent,
    PasswordResetComponent,
    ScreenLoginComponent,
    SendCodeComponent,
    ResendCodeComponent,
  ];
}
